<template>
  <v-select
    :data-test-id="dataTestId"
    :label="$t('common.platform')"
    v-model="valueInternal"
    :disabled="disabled"
    :items="availablePlatforms"
    :rules="rules"
    item-text="name"
    item-value="code"
    :clearable="clearable"
  >
    <template v-slot:item="data">
      <v-icon class="mr-2">{{ data.item.mdi_icon }}</v-icon>
      {{ data.item.name }}
    </template>

    <template v-slot:selection="data">
      <v-icon class="mr-2">{{ data.item.mdi_icon }}</v-icon>
      {{ data.item.name }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: "PlatformSelect",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    rules: {
      default: undefined
    },
    value: {
      type: String,
      required: false
    },
    dataTestId: {
      type: String,
      required: false
    },
    excludeIds: {
      type: Array,
      required: false,
      default: () => {return []}
    }
  },
  data: function() {
    return {
      valueInternal: undefined
    };
  },
  computed: {
    availablePlatforms: function () {
      let ret = this.$store.state.platforms.filter((item) => {
        return this.excludeIds.indexOf(item.code) === -1
      })
      return ret;
    }
  },
  watch: {
    value: function(val) {
      this.valueInternal = val;
    },
    valueInternal: function(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.valueInternal = this.value;
  },
  methods: {}
};
</script>